import type { CellContext, ColumnDef } from "@tanstack/react-table";

import { policiesActions } from "./actions";
import { policyFormatter } from "./name";
import { statusFormatter } from "./status";
import { tagsFormatter } from "./tags";

import type { IVulnerabilityPoliciesData } from "../types";
import { formatDate } from "utils/date";
import { translate } from "utils/translations/translate";

const getColumns = (
  tPath: string,
  organizationId: string,
  userRole: string,
): ColumnDef<IVulnerabilityPoliciesData>[] => {
  const ACTION_SIZE = 200;
  const NO_ACTION_SIZE = 300;
  const minSize = userRole === "user" ? NO_ACTION_SIZE : ACTION_SIZE;

  return [
    {
      accessorKey: "name",
      cell: (cell): JSX.Element => policyFormatter(String(cell.getValue())),
      header: translate.t(`${tPath}type`),
      id: "name",
      maxSize: 800,
      minSize: 350,
    },
    {
      accessorKey: "status",
      cell: (cell): JSX.Element => statusFormatter(String(cell.getValue())),
      header: translate.t(`${tPath}status`),
      id: "status",
      minSize,
    },
    {
      accessorKey: "lastStatusUpdate",
      cell: (cell): string => formatDate(String(cell.getValue() ?? "")),
      header: translate.t(`${tPath}date`),
      id: "lastStatusUpdate",
      minSize,
    },
    {
      accessorKey: "tags",
      cell: (cell): JSX.Element => tagsFormatter(String(cell.getValue())),
      enableSorting: false,
      header: translate.t(`${tPath}tags`),
      id: "tags",
      size: 350,
    },
    ...(userRole === "user"
      ? []
      : [
          {
            accessorKey: "action",
            cell: (
              cell: CellContext<IVulnerabilityPoliciesData, unknown>,
            ): React.ReactNode =>
              policiesActions({ cell: cell.row.original, organizationId }),
            enableSorting: false,
            header: translate.t(`${tPath}action`),
          },
        ]),
  ];
};

export { getColumns };
